<div class="register-container">
  <div class=" container">
    <div class="row h-100">
      <!-- 1st step left section heading of create account -->
      <div class="p-0 ps-0" [ngClass]="{'d-md-block col-lg-5 left-section-step1': curr_step == 1, 'd-none' : curr_step != 1 }">
        <div class="py-lg-5 py-4 h-100 pe-lg-5">
          <div class="px-lg-0 px-3">
            <h1>Welcome to the Vet Times</h1>
            <h4 class="my-4">Sign up to get the latest insights, when you need them.</h4>
            <div>
              <div class="d-flex gap-2">
                <i class="icon-email-subscription pe-1 pt-1"></i>
                <p class="mb-4">Go straight to the news that matters to you.</p>
              </div>
              <div class="d-flex gap-2">
                <i class="icon-clinic pe-1 pt-1"></i>
                <p class="mb-4">Access clinical content to support your decision-making.</p>
              </div>
              <div class="d-flex gap-2">
                <i class="icon-heart pe-1 pt-1"></i>
                <p>Find jobs and connect with the Vet Times community.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 1st step left section heading of create account ends -->

      <!-- 2nd step left section heading of create account -->
      <div class="px-lg-0 vt-border-right mt-lg-5 mt-4" [ngClass]="{ 'd-md-block col-lg-3 left-section-step2': curr_step == 2, 'd-none' : curr_step != 2 }">
        <div class="pe-lg-5">
          <h1 class="mb-4">Create your account</h1>
          <h4 class="lh-base mb-0">Tell us a little more about your role to unlock full access.</h4>
        </div>
      </div>
      <!-- 2nd step left section heading of create account ends -->

      <!-- 1st step right section form of create account -->
      <div class="col-lg-7 p-0 col-12" [ngClass]="{ 'd-md-block right-section-step1': curr_step == 1, 'd-none' : curr_step != 1 }">
        <div class="right-section py-lg-5 py-4 ps-lg-5 px-lg-0 px-3">
          <form [formGroup]="form">
            <div class="onboarding-card">
              <h2>Create your account</h2>

              <div class="d-flex gap-2 mb-3">
                <p class="font-19 font-fraunces">Already have an account?</p>
                <a class="font-fraunces font-19 fw-bold btn-lined" routerLink="/login">Sign in</a>
              </div>

              <div class="d-flex gap-3 flex-column">
                <div class="has-validation">
                  <label for="name" class="text-black fw-medium font-17 pb-2 required">First name</label>
                  <input type="text" class="form-control" [ngClass]="{'is-invalid': form.get('name')?.errors &&
                    form.get('name')?.touched}" [placeholder]="'Please enter your first name'" formControlName="name" placeholder="" id="name" maxlength="254" />

                  <div *ngIf="form.get('name')?.hasError('required') && form.get('name')?.touched" class="invalid-feedback">
                    Name is required.
                  </div>

                  <div *ngIf="form.get('name')?.hasError('pattern') && form.get('name')?.touched" class="invalid-feedback">
                    Name can only contain alphabets, one hyphen, one apostrophe, and spaces.
                  </div>
                </div>

                <div class="has-validation">
                  <label for="last_name" class="text-black fw-medium font-17 pb-2 required">Last name</label>
                  <input type="text" class="form-control" [ngClass]="{'is-invalid': form.get('last_name')?.errors &&
                    form.get('last_name')?.touched}" [placeholder]="'Please enter your last name'" formControlName="last_name" placeholder="" id="last_name" maxlength="254"/>

                  <div *ngIf="form.get('last_name')?.hasError('required') && form.get('last_name')?.touched" class="invalid-feedback">
                    Last name is required.
                  </div>

                  <div *ngIf="form.get('last_name')?.hasError('pattern') && form.get('last_name')?.touched
                  " class="invalid-feedback">
                    Last name can only contain alphabets, one hyphen, one apostrophe, and spaces.
                  </div>
                </div>

                <div class="has-validation">
                  <label for="email" class="text-black fw-medium pb-2 required">E-mail</label>
                  <input type="email" class="form-control" [ngClass]="{'is-invalid': (form.get('email')?.errors &&
                    form.get('email')?.touched) || errorMessage.email}" (keyup)="errorMessage.email = ''"
                    placeholder="Please enter your e-mail" formControlName="email" id="email" aria-describedby="emailHelp"
                    maxlength="254" required />

                  <div *ngIf="form.get('email')?.hasError('required') && form.get('email')?.touched " class="invalid-feedback">
                    E-mail is required.
                  </div>

                  <div class="invalid-feedback" *ngIf="form.get('email')?.hasError('email') && form.get('email')?.touched &&
                    !form.get('email')?.hasError('pattern')">
                    Invalid e-mail address
                  </div>

                  <div class="invalid-feedback" *ngIf="form.get('email')?.hasError('pattern') && form.get('email')?.touched">
                    Please enter a correct e-mail.
                  </div>

                  <div *ngIf="errorMessage.email && !form.get('email')?.errors" class="invalid-feedback">
                    {{ errorMessage.email }}
                    <a href='#' class="fw-medium text-decoration-none" *ngIf="showResendLink"
                      (click)="resendVerificationEmail($event)">
                      resend the verification e-mail
                    </a>
                  </div>
                </div>

                <div class="has-validation">
                  <label for="password" class="text-black fw-medium font-17 pb-2 required">Password</label>
                  <div class="password-wrap">
                    <input type="{{ showPassword ? 'text' : 'password' }}" placeholder="Password" class="form-control"
                      [ngClass]="{'is-invalid': form.get('password')?.errors && form.get('password')?.touched}"
                      formControlName="password" id="password" maxlength="254" required />

                    <a class="show-password active text-black" href="#" (click)="togglePasswordVisibility($event)">
                      {{ showPassword ? "Hide" : "Show" }}
                    </a>

                    <div *ngIf="form.get('password')?.hasError('required') && form.get('password')?.touched" class="invalid-feedback">
                      Password is required.
                    </div>

                    <div *ngIf="form.get('password')?.hasError('minlength') && form.get('password')?.touched &&
                      !form.get('password')?.hasError('required')" class="invalid-feedback">
                      Please enter at least 8 character password.
                    </div>
                  </div>
                </div>

                <button  *ngIf="!loader" type="submit" class="btn-outlined bg-black text-white vt-border signup-btn"
                  (click)="next(); isDisable(); trackButtonClick({'button': 'Next', page: 'Register'})">
                  <span class="d-flex align-items-center gap-2">Next <i class="icon-pagination-forward font-12"></i></span>
                </button>
                <spinner *ngIf="loader"></spinner>

                <p *ngIf="curr_step === 1  || curr_step === 2" class="font-14 text-black lh-base">
                  By clicking ‘next’ you agree to our
                  <a class="btn-lined" [href]="vettimesUrl + 'terms-conditions'">
                    Terms and conditions
                  </a>
                  and confirm you have read our
                  <a class="btn-lined" [href]="vettimesUrl + 'privacy-policy'">
                    privacy policy
                  </a>
                  and
                  <a class="btn-lined" [href]="vettimesUrl+ 'cookie-policy'">
                    cookies policy
                  </a>
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- 1st step right section form of create account ends-->

      <!-- 2nd step right section form of create account -->
      <div class="col-lg-9 p-0 col-12" [ngClass]="{ 'd-md-block right-section-step2': curr_step == 2, 'd-none' : curr_step != 2 }">
        <div class="right-section py-lg-5 py-4 ps-lg-5 px-lg-0 px-3">
          <form [formGroup]="form">
            <div class="onboarding-card">
              <h3 class="onboarding-card-title">Select your role</h3>
              <div>
                <div class="roles-wrap mb-4 pb-2 pb d-flex flex-wrap gap-3">
                  <a href="#" (click)="selectJobRole($event, 'C'); trackButtonClick({'role': 'Veterinary surgeon', page: 'Register'})"
                    class="role-item rounded-pill fw-bold font-14 d-flex justify-content-center align-items-center"
                    [ngClass]="{ active: form.get('job_role')?.value === 'C' }">
                    Veterinary surgeon
                  </a>

                  <a href="#" (click)="selectJobRole($event, 'D'); trackButtonClick({'role': 'Registered veterinary nurse', page: 'Register'})"
                    class="role-item rounded-pill fw-bold font-14 d-flex justify-content-center align-items-center"
                    [ngClass]="{ active: form.get('job_role')?.value === 'D' }">
                    Registered veterinary nurse
                  </a>

                  <a href="#" (click)="selectJobRole($event, 'S'); trackButtonClick({'role': 'Veterinary student', page: 'Register'})"
                    class="role-item rounded-pill fw-bold font-14 d-flex justify-content-center align-items-center"
                    [ngClass]="{ active: form.get('job_role')?.value === 'S' }">
                    Veterinary student
                  </a>

                  <a href="#" (click)="selectJobRole($event, 'G'); trackButtonClick({'role': 'Student veterinary nurse', page: 'Register'})"
                    class="role-item rounded-pill fw-bold font-14 d-flex justify-content-center align-items-center"
                    [ngClass]="{ active: form.get('job_role')?.value === 'G' }">
                    Student veterinary nurse
                  </a>

                  <a href="#" (click)="selectJobRole($event, 'O'); trackButtonClick({'role': 'Non-Clinical', page: 'Register'})"
                    class="role-item rounded-pill fw-bold font-14 d-flex justify-content-center align-items-center"
                    [ngClass]="{ active: form.get('job_role')?.value === 'O' }">
                    Non-Clinical
                  </a>
                </div>

                <div class="has-validation mb-3" *ngIf="form.get('job_role')?.value === 'O'">
                  <label for="job_types_other" class="text-black fw-medium font-17 pb-2 required">Other</label>
                  
                  <input type="text" class="form-control" [ngClass]="{'is-invalid': form.get('job_types_other')?.errors &&
                    form.get('job_types_other')?.touched}" [placeholder]="'Please enter other job type'" formControlName="job_types_other" 
                    placeholder="" id="job_types_other" maxlength="254" (input)="errorMessage.job_types_other = ''; isDisable();" />

                  <div *ngIf="form.get('job_types_other')?.hasError('required') && form.get('job_types_other')?.touched" class="invalid-feedback">
                    Other is required.
                  </div>
                </div>

                <div class=" mb-3">
                  <label for="country_of_residence" class="text-black font-17 fw-medium pb-2 required">Country of residence</label>
                  <select class="form-select is-invalid country-dropdown c-pointer" [ngClass]="{ 'is-invalid': form.get('country_of_residence')?.errors &&
                    form.get('country_of_residence')?.touched}" aria-label="Default select example" formControlName="country_of_residence"
                    id="country_of_residence" (change)="onCountryChange(); isDisable()">
                    <option value="">Please select</option>
                    <option *ngFor="let country of countries" [value]="country.country_name">{{ country.country_name }}
                    </option>
                  </select>

                  <div *ngIf="form.get('country_of_residence')?.errors && form.get('country_of_residence')?.touched" class="invalid-feedback">
                    Country of residence is required.
                  </div>
                </div>

                <div class="mb-lg-4 mb-3" *ngIf="showRcvs && rcvsFieldsName">
                  <label for="rcvs" class="d-flex font-17 fw-medium justify-content-between pb-2 text-black w-100">{{rcvsFieldsName}}
                    <a href="javascript:void(0)" (click)="findRcvsNumber($event)" *ngIf="rcvsFieldsName == 'RCVS number'" class="btn-lined">
                      Find it here
                    </a>
                  </label>

                  <input type="text" class="form-control" [ngClass]="{'is-invalid': (form.get('rcvs')?.errors && form.get('rcvs')?.touched) ||
                    errorMessage.rcvs}" formControlName="rcvs" (input)="errorMessage.rcvs = ''; isDisable(); validateRcvsInput()"
                    placeholder="" id="rcvs" [attr.maxlength]="rcvsFieldsName == 'RCVS number' ? 7 : 254" />

                  <div *ngIf="form.get('rcvs')?.hasError('pattern') && form.get('rcvs')?.touched" class="invalid-feedback">
                    {{rcvsFieldsName}} is invalid.
                  </div>

                  <div *ngIf="errorMessage.rcvs && !form.get('rcvs')?.errors" class="invalid-feedback">{{ errorMessage.rcvs }}</div>

                  <div *ngIf="(form.get('rcvs')?.hasError('maxlength') || form.get('rcvs')?.hasError('minlength')) &&
                    form.get('rcvs')?.touched && !form.get('rcvs')?.hasError('pattern')" class="invalid-feedback">
                    {{rcvsFieldsName}} must be exactly 7 characters long.
                  </div>
                </div>

                <div class="d-flex gap-2 my-4">
                  <input type="checkbox" class="form-check-input p-0" (change)="isDisable()" id="agreeTerms" formControlName="agreeTerms"/>
                  <label class="form-label" for="agreeTerms">
                    Please confirm that you are a veterinary professional or work in a related industry to see clinical information.
                  </label>
                </div>

                <div class="d-flex gap-2 my-4">
                  <input type="checkbox" class="form-check-input p-0" id="consent_third_party_sharing" formControlName="consent_third_party_sharing"/>
                  <label class="form-label" for="consent_third_party_sharing">
                    To support Vet Times and receive free, valuable content, I consent to Vet Times sharing my data with trusted third-party partners. Review our Privacy Policy.
                  </label>
                </div>

                <div class="d-flex justify-content-between gap-3">
                  <button *ngIf="!loader" type="submit" class="btn-outlined bg-black text-white border mb-3 create-account-btn" [disabled]="isDisabled"
                    (click)="onSubmit();  trackButtonClick({'button': 'Create account', page: 'Register'})">
                    <span>Create account</span>
                  </button>
                  <spinner *ngIf="loader"></spinner>
                </div>

                <div class="d-flex gap-2 align-items-center ">
                  <p>Already have an account? </p>
                  <a class="font-14 fw-bold btn-lined" routerLink="/login">Sign in</a>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- 2nd step right section form of create account ends -->
    </div>
  </div>
</div>

<!-- 3rd step right section form of create account -->
<div class="container-fluid align-items-center verify-email" [ngClass]="{ 'd-md-flex verify-email': curr_step == 3, 'd-none' : curr_step != 3 }">
  <div class="right-section py-lg-5 py-4 col-lg-6 offset-lg-3 text-center">
    <div class="onboarding-card">
      <img src={{verifiedImage}} alt="" />
      <h1 class="onboarding-card-title my-3">Please verify your email</h1>

      <div class="content">
        <h4 class="text lh-base">
          We have sent email to {{ form.value.email }} for email address confirmation, check your spam folder. Click link in
          received email to complete registration.
        </h4>

        <p class="text mb-0 mt-4">
          <spinner *ngIf="loader"></spinner>
          <span *ngIf="!loader">
            Didn&apos;t receive the confirmation email?
            <a href="#" class="btn-lined" (click)="resendVerificationEmail($event)">
              Resend
            </a>
          </span>
        </p>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid align-items-center verify-email" [ngClass]="{ 'd-md-block': curr_step == 4, 'd-none' : curr_step != 4 }">
  <div class="right-section py-lg-5 py-4 col-lg-6 offset-lg-3 text-center">
    <div class="onboarding-card">
      <img src={{verifiedImage}} alt="" />
      <h1 class="onboarding-card-title mt-2">Link expired or already used</h1>

      <div class="content">
        <h4 class="text lh-base mb-4">
          We're sorry, the verification link is expired or has already been used. If you already have an account, please log in.
          If you don't have an account yet, you can sign up for one.
        </h4>
      </div>

      <div class="d-flex justify-content-center gap-3 ">
        <a href="" routerLink="/login" class="btn-outlined bg-black text-white vt-border px-4 py-3 fs-6">Login</a>
        <a href="" routerLink="/register" class="btn-outlined vt-border px-4 py-3 fs-6">Sign up</a>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid align-items-center verify-email" [ngClass]="{ 'd-md-block': curr_step == 5, 'd-none' : curr_step != 5 }">
  <div class="right-section py-lg-5 py-4 col-lg-6 offset-lg-3 text-center">
    <div class="onboarding-card" >
      <img src={{signupTick}} alt="" />
      <h1 class="onboarding-card-title mt-2">Your account has been created</h1>

      <div class="content">
        <h4 class="text-center lh-base">Stay up to date with veterinary news.</h4>
        <a [attr.href]="vettimesUrl + 'user/onboarding'" class="btn-outlined bg-black text-white vt-border"
          (click)="trackButtonClick({'button': 'Customise your subscription', page: 'Register'})">
          Customise your subscription
        </a>
      </div>
    </div>
    <div>
      <visit-products></visit-products>
    </div>
  </div>
</div>
<!-- 3rd step right section form of create account ends -->
